"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateService = exports.sendMessage = exports.getInputsData = exports.getAuditVersion = exports.createMessage = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _handle_http = require("../../../global-files/handle_http");

var getAuditVersion = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(articleId, setState, token) {
    var auditResponse;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get("".concat(process.env.REACT_APP_GET_AUDIT, "?articleId=").concat(articleId), {
              headers: {
                Authorization: token
              }
            });

          case 2:
            auditResponse = _context.sent;

            if (auditResponse.status === 200) {
              setState(JSON.parse(auditResponse.data.body).data || "{}");
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAuditVersion(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

exports.getAuditVersion = getAuditVersion;

var getInputsData = function getInputsData(services, activeRetailer, setDatasheetState, setDescriptionState) {
  if (services.length > 0) {
    var _services$0$activeRet, _services$, _services$2;

    if ((_services$0$activeRet = services[0][activeRetailer.id]) !== null && _services$0$activeRet !== void 0 && _services$0$activeRet.data) services[0][activeRetailer.id].data = Object.values(services[0][activeRetailer.id].data);
    var datagroups = services[0][activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id];
    var inputs = (_services$ = services[0]) === null || _services$ === void 0 ? void 0 : _services$.inputs;
    var descriptions = (_services$2 = services[1]) === null || _services$2 === void 0 ? void 0 : _services$2.filter(function (service) {
      return (service === null || service === void 0 ? void 0 : service.id) === (activeRetailer === null || activeRetailer === void 0 ? void 0 : activeRetailer.id);
    });
    setDatasheetState([datagroups, inputs]);
    setDescriptionState(descriptions);
  }
};

exports.getInputsData = getInputsData;

var translateService = function translateService(tab) {
  switch (tab) {
    case "description":
    case "Descripción":
      return "Descripciones";

    case "datasheet":
    case "Ficha técnica":
      return "Fichas técnicas";

    case "images":
    case "Imágenes":
      return "Imágenes";
  }
};

exports.translateService = translateService;

var createMessage = function createMessage(retailers, idRetailer, oldStatus, newStatus, service) {
  var _ref2 = (retailers === null || retailers === void 0 ? void 0 : retailers.filter(function (ret) {
    return ret.id === idRetailer;
  })) || [],
      _ref3 = (0, _slicedToArray2.default)(_ref2, 1),
      retailer = _ref3[0];

  return "".concat(translateService(service), " de ").concat(retailer.name, " |").concat(oldStatus, "| a |").concat(newStatus);
};

exports.createMessage = createMessage;

var sendMessage = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(data) {
    var paramsBody, paramsHeader;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            paramsBody = data.paramsBody, paramsHeader = data.paramsHeader;
            return _context2.abrupt("return", (0, _handle_http.fetchPOST)(process.env.REACT_APP_CREATE_MESSAGES, paramsBody, paramsHeader));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function sendMessage(_x4) {
    return _ref4.apply(this, arguments);
  };
}();

exports.sendMessage = sendMessage;